import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Валидатор для проверки корректности диапазона дат (дата начала не должна быть позже даты окончания)
 */
export function dateRangeValidator(startFieldName: string, endFieldName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startControl = control.get(startFieldName);
    const endControl = control.get(endFieldName);

    if (!startControl || !endControl) {
      return null;
    }

    const startValue = startControl.value;
    const endValue = endControl.value;

    const startDateRaw = startValue?.startDate || startValue;
    const endDateRaw = endValue?.startDate || endValue;

    if (!startDateRaw || !endDateRaw) {
      // Clear error if either startsAt or endsAt is missing
      if (endControl.hasError("invalidDateRange")) {
        const { invalidDateRange, ...otherErrors } = endControl.errors || {};
        endControl.setErrors(Object.keys(otherErrors).length > 0 ? otherErrors : null);
      }
      return null;
    }

    const start = new Date(startDateRaw);
    const end = new Date(endDateRaw);

    if (!isNaN(start.getTime()) && !isNaN(end.getTime()) && start > end) {
      const errors = { ...endControl.errors, invalidDateRange: true };
      endControl.setErrors(errors);
      return { invalidDateRange: true };
    }

    // If valid, clear the error if it was previously set
    if (endControl.hasError("invalidDateRange")) {
      const { invalidDateRange, ...otherErrors } = endControl.errors || {};
      endControl.setErrors(Object.keys(otherErrors).length > 0 ? otherErrors : null);
    }

    return null;
  };
}
